import * as React from 'react';
import {
  HomeIcon,
  ZoneEditorIcon,
  OrgBrowserIcon,
  UserManagementIcon,
  AuditLogsIcon,
  TasksIcon,
  StoreIcon,
  EposUploadIcon,
  ReportsIcon,
  ZoneEditorSandbox,
  DeviceManagement,
  CustomerCenterIcon,
  OthersIcon,
  MapsIcon,
  EmployeeDashboardIcon,
} from 'src/assets/icons/navigation';
import { HealthIcon } from 'src/assets/icons/HealthIcon';
import { PauseIcon } from 'src/assets/icons/pause-icon';
import { InstallIcon } from 'src/assets/icons/InstallIcon';
import { BlockIcon } from 'src/assets/icons/BlockIcon';
import { GenerateReportIcon } from 'src/assets/icons/GenerateReportIcon';
import { UI_ROUTES, NestedAndExternalRouteIconKey, NESTED_AND_EXTERNAL_ROUTE_ICON_KEY_MAP } from './routes';

export type Routes = Extract<
  keyof typeof UI_ROUTES,
  | 'HOME'
  | 'ZONE_EDITOR'
  | 'ORG_BROWSER'
  | 'USER_MANAGEMENT'
  | 'AUDIT_LOGS'
  | 'TASKS'
  | 'STORE_MANAGEMENT'
  | 'DEVICE_MAP'
  | 'SIM_DETAIL'
  | 'EPOS_UPLOAD'
  | 'DEVICE_MANAGEMENT'
  | 'REPORT'
  | 'ZONE_SANDBOX'
  | 'CUSTOMER_CENTRE'
  | 'DEVICE_STATUS'
  | 'INSTALLS'
  | 'NEW_INSTALL'
  | 'REPORT_PAUSED_STATUS'
  | 'REPORT_BLACKLIST'
  | 'REPORT_GENERATE'
>;

export type RouteIconKeys = (typeof UI_ROUTES)[Routes] | NestedAndExternalRouteIconKey;

export type RoutesIcons = Record<RouteIconKeys, React.FunctionComponent>;

export const ROUTE_ICONS: RoutesIcons = {
  [UI_ROUTES.HOME]: HomeIcon,
  [UI_ROUTES.ZONE_EDITOR]: ZoneEditorIcon,
  [UI_ROUTES.ORG_BROWSER]: OrgBrowserIcon,
  [UI_ROUTES.USER_MANAGEMENT]: UserManagementIcon,
  [UI_ROUTES.AUDIT_LOGS]: AuditLogsIcon,
  [UI_ROUTES.TASKS]: TasksIcon,
  [UI_ROUTES.STORE_MANAGEMENT]: StoreIcon,
  [UI_ROUTES.DEVICE_MAP]: MapsIcon,
  [UI_ROUTES.SIM_DETAIL]: HealthIcon,
  [UI_ROUTES.EPOS_UPLOAD]: EposUploadIcon,
  [UI_ROUTES.DEVICE_MANAGEMENT]: DeviceManagement,
  [UI_ROUTES.REPORT]: ReportsIcon,
  [UI_ROUTES.ZONE_SANDBOX]: ZoneEditorSandbox,
  [NESTED_AND_EXTERNAL_ROUTE_ICON_KEY_MAP.OTHERS]: OthersIcon,
  [UI_ROUTES.DEVICE_STATUS]: HealthIcon,
  [UI_ROUTES.INSTALLS]: InstallIcon,
  [UI_ROUTES.NEW_INSTALL]: InstallIcon,
  [NESTED_AND_EXTERNAL_ROUTE_ICON_KEY_MAP.DEVICE_OPS]: DeviceManagement,
  [UI_ROUTES.REPORT_PAUSED_STATUS]: PauseIcon,
  [UI_ROUTES.REPORT_BLACKLIST]: BlockIcon,
  [UI_ROUTES.REPORT_GENERATE]: GenerateReportIcon,
  [NESTED_AND_EXTERNAL_ROUTE_ICON_KEY_MAP.EMPLOYEE_DASHBOARD]: EmployeeDashboardIcon,
  /** @deprecated */
  [UI_ROUTES.CUSTOMER_CENTRE]: CustomerCenterIcon,
};
